<div class="pdf-toolbar">
  <div class="pdf-toolbar__group">
    <button
      type="button"
      class="pdfm-btn pdfm-btn--light"
      [disabled]="currentPage <= 1"
      (click)="prev()"
      title="Previous page"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>

    <span class="pdf-toolbar__page-info">
      <input
        type="number"
        class="pdf-toolbar__page-input"
        min="1"
        [max]="totalPages"
        [value]="currentPage"
        (change)="goToPage($any($event.target).value)"
        (keydown.enter)="$any($event.target).blur()"
        title="Go to page"
      />
      <span class="pdf-toolbar__page-total">/ {{ totalPages }}</span>
    </span>

    <button
      type="button"
      class="pdfm-btn pdfm-btn--light"
      [disabled]="currentPage >= totalPages"
      (click)="next()"
      title="Next page"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</div>
